import * as actions from './actions'
import { DEFAULT_USER_TIMEZONE } from 'qap/constants'

import type { State, Action } from './type'

export const initialState = {
  preferences: undefined,
  availableTimezones: undefined,
  fetched: false,
  saving: false,
  saved: false,
  selectedTimezone: undefined,
  currentTime: undefined,
  errors: undefined
} as const

const reducer = (state: State | null | undefined = initialState, action: Action) => {
  switch (action.type) {
    case actions.SET_TIMEZONE_PREFERENCE:
      return {
        ...state,
        preferences: {
// @ts-expect-error - TS18047 - 'state' is possibly 'null'. - fall through
          ...state.preferences,
          timezone: action.value
        },
        selectedTimezone: action.value,
        saved: false
      }
// @ts-expect-error - TS2678 - Type '"API_USER_PREFERENCES_SHOW_SUCCESS"' is not comparable to type '"API_USER_PREFERENCES_SHOW" | "API_USER_PREFERENCES_UPDATE" | "SET_TIMEZONE_PREFERENCE" | "SET_TIME_DISPLAY_EXAMPLE"'. - fall through
    case actions.FETCH_GENERAL_PREFERENCES_SUCCESS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'never'. - fall through
        ...action.data,
        fetched: true,
        saved: false,
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'never'. - fall through
        selectedTimezone: action.data.preferences.timezone || DEFAULT_USER_TIMEZONE
      }
    case actions.SAVE_GENERAL_PREFERENCES:
      return {
        ...state,
        saving: true,
        saved: false
      }
// @ts-expect-error - TS2678 - Type '"API_USER_PREFERENCES_UPDATE_SUCCESS"' is not comparable to type '"API_USER_PREFERENCES_SHOW" | "API_USER_PREFERENCES_UPDATE" | "SET_TIMEZONE_PREFERENCE" | "SET_TIME_DISPLAY_EXAMPLE"'. - fall through
    case actions.SAVE_GENERAL_PREFERENCES_SUCCESS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'never'. - fall through
        ...action.data,
        saving: false,
        saved: true
      }
// @ts-expect-error - TS2678 - Type '"API_USER_PREFERENCES_UPDATE_FAILURE"' is not comparable to type '"API_USER_PREFERENCES_SHOW" | "API_USER_PREFERENCES_UPDATE" | "SET_TIMEZONE_PREFERENCE" | "SET_TIME_DISPLAY_EXAMPLE"'. - fall through
    case actions.SAVE_GENERAL_PREFERENCES_FAILURE:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'never'. - fall through
        errors: action.errors,
        saving: false,
        saved: false
      }
    case actions.SET_TIME_DISPLAY_EXAMPLE:
      return {
        ...state,
        currentTime: Date.now(),
        saving: false,
        saved: false
      }
    default:
      return state
  }
}

export default reducer
